import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7ba05f9e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/trip-admin-web_test/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ba05f9e')) {
      api.createRecord('7ba05f9e', component.options)
    } else {
      api.reload('7ba05f9e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7ba05f9e", function () {
      api.rerender('7ba05f9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/itinerary/restaurant/index.vue"
export default component.exports